

import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';

Vue.config.productionTip = false;


/*引入axios 并引入Qs模块处理request数据*/
import axios from 'axios';
import Qs from 'qs';
/*引入axios所用到的api*/
import $api from './config/config.api.js';
const $axios = axios.create({
baseURL: $api.API,
timeout: 5000,
headers: {

'Content-Type': 'application/x-www-form-urlencoded;' //请求头
},
transformRequest: [function(data) {
data = Qs.stringify(data) 
return data;
}]
});
Vue.prototype.axios = axios;
Vue.prototype.$api = $api; 
Vue.prototype.$axios = $axios;
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

Vue.directive('transfer-dom', TransferDom);
import Popup from 'vux/src/components/popup/index.vue'

Vue.component('popup', Popup);
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin);
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(AlertPlugin);
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

Vue.use(WechatPlugin);
import XButton from 'vux/src/components/x-button/index.vue'

Vue.component('x-button', XButton);
import Msg from 'vux/src/components/msg/index.vue'

Vue.component('msg', Msg);
import md5 from 'vux/src/tools/md5/index.js'

Vue.prototype.$md5 = md5;
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin);











/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
methods: {
config() {
this.$axios.get('', { params: { do: "sconfig", url: window.location.href } })
.then(({ data }) => {
if (data.result == 0) {
this.$wechat.config(Object.assign(data, { debug: false, jsApiList: ['closeWindow', 'scanQRCode', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'hideMenuItems'] }));
} else {
console.log(data)
}
})
.catch(err => {
console.log(err);
});
},
init() {
const link = 'http://www.wcareer.cn/club';
const shareData = {
title: '嘉年华报名入口', // 分享标题
desc: '优果生涯SUC精英讲师团围绕“我的专业概述”主题进行分享，且现场深度互动交流，主要包含两大模块：一是专业学科探究：对高中生尚不了解的专业，讲师团开发的课程涉及专业概览，学科课程，就业情况，实习感悟，学长寄语等模块，让高中生从学校生活和社会生活两大角度提前了解大学即将就读的专业。二是.....',
link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
imgUrl: 'http://www.wcareer.cn/img/icon-logo.png', // 分享图标
};
this.$wechat.hideMenuItems({
menuList: ['menuItem:copyUrl', 'menuItem:share:facebook', 'menuItem:favorite', 'menuItem:share:email', 'menuItem:share:brand'] 
});
this.$wechat.onMenuShareTimeline(shareData);
this.$wechat.onMenuShareAppMessage(shareData);
this.$wechat.onMenuShareQQ(shareData);
this.$wechat.onMenuShareWeibo(shareData);
this.$wechat.onMenuShareQZone(shareData);
}
},
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js